import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcNotificationCalendarCleaned = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2 6H14V3.99999C14 3.26333 13.4033 2.66666 12.6667 2.66666H10.6667H5.33333H3.33333C2.59667 2.66666 2 3.26333 2 3.99999V6Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.6667 1.33333V2.66666M10.6667 3.99999V2.66666M5.33333 1.33333V2.66666M5.33333 3.99999V2.66666M2 3.99999C2 3.26333 2.59667 2.66666 3.33333 2.66666H5.33333M2 3.99999V12.6667C2 13.4033 2.59667 14 3.33333 14H12.6667C13.4033 14 14 13.4033 14 12.6667V3.99999M2 3.99999V6H14V3.99999M14 3.99999C14 3.26333 13.4033 2.66666 12.6667 2.66666H10.6667M10.6667 2.66666H5.33333",
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	})]
});
const ForwardRef = forwardRef(SvgIcNotificationCalendarCleaned);
export default ForwardRef;
